import { faVault } from "@fortawesome/pro-duotone-svg-icons/faVault";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_PROJECTS_LINK: Breadcrumb = {
  icon: faVault,
  name: "Cases",
  to: "/dashboard/projects",
};
